import { useMemo } from 'react';
import { STATE } from 'src/constants';
import { useGetMultipleLatestReadings } from 'src/hooks/apiHooks/useGetMultipleLatestReadings';
import { useGetLatestGatewayReadings } from 'src/hooks/useGetLatestGatewayReadings';
import { AssetType } from 'src/features/sites/types/types';

type Props = {
  assetActiveAlarm: number | null; //comes from the WidgetComponent
  runMode: boolean | null; //comes from the WidgetComponent
  asset: AssetType | undefined;
};

//Add return if the selected widget is not pump
export const usePumpData = ({ asset, assetActiveAlarm, runMode }: Props) => {
  const pumpAsset = asset?.assignedTags?.find((tag) => tag.tagName.toLowerCase() === STATE);

  const assignedTagId = pumpAsset?.assignedTagId;
  const gatewayId = pumpAsset?.assignedGatewayId;

  const { readings: latestReadings, isDataReady } = useGetLatestGatewayReadings({
    gatewayId: gatewayId,
    tagId: assignedTagId,
  });

  const { readingsMap: multipleReadings, isDataReady: isMultipleDataReady } =
    useGetMultipleLatestReadings({
      items: asset?.assignedAlarmTags,
    });

  const values = Object.values(multipleReadings)?.map((tagData) => {
    const tagId = Object.keys(tagData)[0];
    const values = tagData[tagId]?.values ?? {};
    return Object.values(values)[0];
  });
  const isAlarmActive: boolean =
    assetActiveAlarm !== null ? assetActiveAlarm === 1 : values.some((item) => Number(item) > 0);

  const readingsRawInputName = assignedTagId && latestReadings[assignedTagId];
  const readingsValues = readingsRawInputName?.values;
  const readingValueList = readingsValues && Object.values(readingsValues);
  const readingValue = readingValueList && readingValueList[0];

  let modeValue;
  if (runMode !== null) {
    modeValue = runMode;
  } else if (runMode === null) {
    modeValue = readingValue;
  }

  const toogleLabel = modeValue ? 'On' : 'Off';

  const isAlarmReady = useMemo(
    () =>
      isMultipleDataReady &&
      (isAlarmActive !== undefined || isAlarmActive === false || isAlarmActive),
    [isMultipleDataReady, isAlarmActive]
  );

  const isReady = isDataReady && isMultipleDataReady && isAlarmReady;

  const isPumpMappedToAlarmTags = asset?.assignedAlarmTags?.some((tag) => tag.assignedAlarmTagId);

  return { toogleLabel, isReady, isPumpMappedToAlarmTags, modeValue, isAlarmActive };
};
